import { ComponentRef, Directive, inject, Input, OnInit } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { takeUntil } from 'rxjs/operators';
import { FoldersListContextMenuComponent } from '../components/folders-list-context-menu/folders-list-context-menu.component';
import { FoldersListStateService } from '../services/folders-list-state.service';

@Directive({
  selector: '[appFoldersListContextMenu]',
  standalone: false,
})
export class FoldersListContextMenuDirective extends ContextMenuDirective implements OnInit {
  @Input()
  public appFoldersListContextMenuWithAdvancedSearch: boolean;
  @Input()
  public appFoldersListContextMenuWithScore: boolean;
  @Input()
  public stchPopoverTrigger: PopoverTrigger = 'click';
  @Input()
  public stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly foldersListStateService = inject(FoldersListStateService);

  protected override registerInstance(componentRef: ComponentRef<FoldersListContextMenuComponent>) {
    componentRef.instance.state = this.foldersListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appFoldersListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appFoldersListContextMenuWithScore;
  }

  protected override registerComponent() {
    return FoldersListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();

    this.foldersListStateService
      .value()
      .pipe(takeUntil(this.alive))
      .subscribe(() => {
        this.isDefaultStateObservable?.next(this.foldersListStateService.state.isDefault());
      });

    this.isDefaultStateObservable?.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.foldersListStateService.state.isDefault()) {
        this.foldersListStateService.state.resetToDefault();
      }
    });
  }
}
